import React, { useEffect, useState } from "react";
import { StyleSheet, Text, ScrollView, TouchableOpacity, View, SafeAreaView, Image } from 'react-native';
import { DataStore } from 'aws-amplify';
import { UserType, AppUser, UserGroup, GroupConversation } from '../../models';
import * as CmnUtil from '../components/CmnUtil';
import IconImages from '../components/IconImages';
import { saveStorage } from "../components/SessionStorage";
import { Header } from "../components/Header";

/** ================================
*  協力組織一覧画面
*  ================================*/
const GroupList = ({ navigation, setGroupProducer }: { navigation: any, setGroupProducer: Function; }) => {

  // 描画準備
  const [ready, setReady] = useState(false);

  // 自組織
  const [colleagues, setColleagues] = useState<AppUser[]>([]);
  // 協力組織一覧
  const [myConversation, setMyConversation] = useState<GroupConversation[]>([]);
  const [userInfo, setUserInfo] = useState<AppUser | undefined>(undefined);

  useEffect(() => {
    executeQuery();
  }, []);

  /**
   * 協力組織一覧取得
   */
  const executeQuery = async () => {
    let tmpConversation: GroupConversation[] = [];

    try {
      const appUser = await CmnUtil.getCurrentUser();
      setUserInfo(appUser);
      // 自組織の取得
      const colleagues = (await DataStore.query(AppUser)).filter(c => c.group.id === appUser!.group.id);
      setColleagues(colleagues)

      // 協力組織一覧の取得
      const conversationList = (await DataStore.query(GroupConversation)).filter(
        c => c.group.id == appUser!.group.id
          && (c.group.groupType == UserType.PRODUCER || c.group.groupType == UserType.INSTRUCTOR)
          && c.isIntergroup);

      await Promise.all(
        conversationList.map(async conversation => {
          const targetConversation = (await DataStore.query(GroupConversation)).filter(c => c.conversation.id == conversation.conversation.id && c.group.id != conversation.group.id);
          const tmpPartner = (await DataStore.query(UserGroup, targetConversation[0].group.id));

          switch (tmpPartner?.groupType) {
            case UserType.PRODUCER:
            case UserType.INSTRUCTOR:
              tmpConversation.push(conversation);
              break;
            default:
              break;
          }
        })
      ).then(() => {
        setMyConversation(tmpConversation);
        setReady(true);
      });

    } catch (e) {
      console.error(e);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      {(colleagues.length > 0) && <View>
        <Header headerText={`自組織: ${userInfo?.group.groupName}`} />
        <TouchableOpacity style={styles.manufacturerItem}>
           {colleagues.map((data: AppUser | null, index: number) => (
            <View key={index} style={styles.userInfo}>
              <CmnUtil.S3Image imageKey={data?.icon} style={styles.userImage} defaultSource={IconImages.icUser} />
              <Text style={styles.userName}>{data?.username}</Text>
            </View>
          ))}
        </TouchableOpacity>
      </View>}
      <View>
        <Header headerText="協力組織 一覧" />
      </View>
      {ready && myConversation.length == 0 && <Text style={{
        fontSize: 20,
        fontWeight: "bold",
        textAlign: "center",
        marginTop: 20,
      }}>協力組織が登録されていません。{"\n"}
        繋がりたい生産者/普及指導員がいる場合は、チャットからシステム管理者へ協力組織登録を依頼することができます。{"\n"}
        (現在は生産者-普及指導員間の協力組織登録のみ可能です)</Text>}

      <View style={styles.container}>
        <ScrollView>
          {myConversation.map((data: GroupConversation, index: number) => (
            <Partner key={index} navigation={navigation} groupConversation={data} userInfo={userInfo!} setGroupProducer={setGroupProducer} />
          ))}
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

/**
 * 作業日誌画面遷移
 */
async function goDiaryTop(navigation: any, setGroupProducer: Function, userGroup: UserGroup) {
  // セッションストレージに保存されているfriendProducerをupdate
  await saveStorage("friendProducer", userGroup.id);
  if (navigation === undefined) {
    setGroupProducer(userGroup.id);
  } else {
    navigation.navigate("DiaryTop");
  }
}

/**
 * 生産者/指導員共通
 */
const Partner = ({ navigation, groupConversation, userInfo, setGroupProducer }: { navigation: any, groupConversation: GroupConversation, userInfo: AppUser, setGroupProducer: Function }) => {
  const [partner, setPartner] = useState<UserGroup | undefined>(undefined);
  const [users, setUsers] = useState<AppUser[]>([]);

  useEffect(() => {
    (async () => {
      // 相手のルーム取得
      const targetConversation = (await DataStore.query(GroupConversation)).filter(c => c.conversation.id == groupConversation.conversation.id && c.group.id != groupConversation.group.id);

      // 相手の組織情報取得
      const tmpPartner = (await DataStore.query(UserGroup, targetConversation[0].group.id));
      setPartner(tmpPartner);
      const appUsers = (await DataStore.query(AppUser)).filter(c => c.group.id == tmpPartner?.id);
      setUsers(appUsers);
    })();
  }, [groupConversation]);

  // チャットルームへ遷移
  const goChatMain = () => {
    navigation.navigate("ChatNavigator", {
      screen: "ChatMain",
      initial: false,
      params: {
        'groupConversation': groupConversation,
        'userInfo': userInfo,
        'partner': partner,
      }
    });
  };

  return (
    <TouchableOpacity
      style={styles.manufacturerItem}
      onPress={() => {
        if (partner?.groupType == UserType.PRODUCER) {
          goDiaryTop(navigation, setGroupProducer, partner!);
        } else {
          goChatMain()
        }
      }} >

      {navigation !== undefined &&
        <TouchableOpacity
          style={styles.chatImage}
          onPress={() => goChatMain()} >
          <Image
            resizeMode="stretch" style={styles.chatIcon}
            source={{ uri: IconImages.icChatBlue }} />
        </TouchableOpacity>}

      <View style={styles.groupInfo}>
        <CmnUtil.S3Image imageKey={partner?.icon} style={styles.groupImage} defaultSource={IconImages.icGroup} />
        <Text style={styles.groupName}>{partner?.groupName}</Text>
      </View>
      {users.map((data: AppUser, index: number) => (
        <View key={index} style={styles.userInfo}>
          <CmnUtil.S3Image imageKey={data?.icon} style={styles.userImage} defaultSource={IconImages.icUser} />
          <Text style={styles.userName}>{data.username}</Text>
        </View>
      ))}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#E2F0D9",
  },
  header: {
    alignItems: "center",
    justifyContent: "center",
    height: 64,
  },
  headerText: {
    fontSize: 18,
  },
  manufacturerItem: {
    width: "90%",
    backgroundColor: "#ffffff",
    paddingTop: 20,
    paddingHorizontal: 10,
    paddingBottom: 20,
    alignItems: "center",
    marginBottom: 20,
    marginHorizontal: "auto",
    shadowColor: "#808080",
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 10
  },
  groupInfo: {
    flexDirection: "row",
    marginTop: 5,
    marginBottom: 20,
  },
  groupImage: {
    borderRadius: 20,
    width: 40,
    height: 40,
    backgroundColor: "#808080",
  },
  groupName: {
    marginLeft: 5,
    height: 40,
    lineHeight: 40,
    fontWeight: "bold",
    fontSize: 18
  },
  userInfo: {
    flexDirection: "row",
    marginTop: 5,
  },
  userImage: {
    borderRadius: 15,
    width: 30,
    height: 30,
    backgroundColor: "#808080",
  },
  userName: {
    marginLeft: 5,
    height: 30,
    lineHeight: 30,
    fontSize: 18
  },
  chatImage: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  chatIcon: {
    borderRadius: 20,
    width: 40,
    height: 40,
  },
  button: {
    backgroundColor: "#7AAD47",
    borderWidth: 1,
    borderColor: "#057E32",
    borderStyle: "solid",
    width: 100,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#808080",
    shadowOffset: { width: -5, height: 5 },
    shadowRadius: 10,
    top: -2
  },
});
export default GroupList;
